import { useEffect } from "react";
import { Form, Input, InputNumber, DatePicker, Select, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "./service-excel.css";

const ServiceExcelClient = ({ record, onSave, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (record) {
      const initialValues = {
        ...record,
        birthDate: record.birthDate ? dayjs(record.birthDate) : null,
      };
      form.setFieldsValue(initialValues);
    }
  }, [record, form]);

  const handleSave = () => {
    form.validateFields().then(values => {
      const updatedRecord = {
        ...record,
        ...values,
        birthDate: values.birthDate ? values.birthDate.format('YYYY-MM-DD') : null,
      };
      onSave(updatedRecord);
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };

  if (!record) return null;

  return (
    <div className="sport-modal">
      <div
        className="sport-modal-overlay"
        onMouseDown={(e) => e.target === e.currentTarget && onCancel()}
      >
        <div
          className="sport-modal-content service-excel-modal-content"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="sport-modal-title">
            <span>Редактирование клиента</span>
            <CloseCircleOutlined
              className="sport-section-title-close"
              onClick={onCancel}
            />
          </div>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Form.Item label="Внешний ID" name="externalId">
              <Input placeholder="Внешний ID" />
            </Form.Item>
            <Form.Item label="ФИО" name="fio">
              <Input placeholder="ФИО" />
            </Form.Item>
            <Form.Item label="Телефон" name="phone">
              <Input placeholder="Телефон" />
            </Form.Item>
            <Form.Item label="EMAIL" name="email">
              <Input placeholder="EMAIL" />
            </Form.Item>
            <Form.Item label="Дата рождения" name="birthDate">
              <DatePicker
                className="service-excel-datepicker"
                format="DD.MM.YYYY"
                allowClear
              />
            </Form.Item>
            <Form.Item label="Адрес" name="address">
              <Input placeholder="Адрес" />
            </Form.Item>
            <Form.Item label="Пол" name="gender">
              <Select
                placeholder="Пол"
                options={[
                  { label: "Ж", value: 0 },
                  { label: "М", value: 1 },
                ]}
              />
            </Form.Item>
            <Form.Item label="№ карты" name="cardNumber">
              <Input placeholder="№ карты" />
            </Form.Item>
            <Form.Item label="Комментарий" name="comment">
              <Input placeholder="Комментарий" />
            </Form.Item>
            <Form.Item label="Депозит" name="deposit">
              <InputNumber
                className="service-excel-inputnumber"
                placeholder="Депозит"
              />
            </Form.Item>
            <Form.Item label="Паспорт" name="passport">
              <Input placeholder="Паспорт" />
            </Form.Item>
            <Form.Item>
              <div className="service-excel-modal-actions">
                <Button onClick={onCancel}>Отмена</Button>
                <Button type="primary" onClick={handleSave}>
                  Сохранить
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

ServiceExcelClient.displayName = "ServiceExcelClient";

export default ServiceExcelClient;

